"use client";

import { CART_COOKIE } from "@/config/cart";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { deleteCookie } from "cookies-next";
import { type ReactNode, useState } from "react";

export default function ReactQueryClientProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            queryFn: () => null,
          },
        },
      }),
  );

  queryClient.getQueryCache().subscribe((event) => {
    if (event?.type === "updated") {
      const { query } = event;
      const { status, error } = query.state;

      if (status === "error") {
        if (error?.message.includes("CART_NOT_FOUND")) {
          deleteCookie(CART_COOKIE);
          void queryClient.invalidateQueries({ queryKey: ["cart"] });
        }
      }
    }
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
